// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__11OAU","content":"LayoutSettings_content__iIb0S"};